import React from 'react';
import { useMediaQuery } from 'react-responsive';
import ExtraLargeGrid from "../GridListV2/ExtraLargeGridList";

// Responsive components for different device widths
const DeviceWrapper = ({ children, query }) => {
  const matches = useMediaQuery(query);
  return matches ? children : null;
};

function ResponsiveV2(props) {
  return (
    <div>
      <ExtraLargeGrid authUser={props.authUser}/>
      {/* Extra Large Desktop */}
      {/* <DeviceWrapper query={{ minWidth: 1500 }}>
      </DeviceWrapper> */}

      {/* Large Desktop */}
      {/* <DeviceWrapper query={{ minWidth: 1200, maxWidth: 1499 }}>
        <ExtraLargeGrid authUser={props.authUser} Device="LargeDesktop" />
      </DeviceWrapper> */}

      {/* Desktop */}
      {/* <DeviceWrapper query={{ minWidth: 992, maxWidth: 1199 }}>
        <ExtraLargeGrid authUser={props.authUser} Device="Desktop" />
      </DeviceWrapper> */}

      {/* Tablet */}
      {/* <DeviceWrapper query={{ minWidth: 768, maxWidth: 991 }}>
        <ExtraLargeGrid authUser={props.authUser} Device="Tablet" />
      </DeviceWrapper> */}

      {/* Mobile */}
      {/* <DeviceWrapper query={{ maxWidth: 767 }}>
        <ExtraLargeGrid authUser={props.authUser} Device="Mobile" />
      </DeviceWrapper> */}
    </div>
  );
}

export default ResponsiveV2;
